import { XInput } from '@playcastdotio/CoreTypes';
import clsx from 'clsx';
// import { useMobilePortrait } from './useMobilePortrait';

interface GamepadStateProps {
  gamepad: XInput;
  location: 'left' | 'right';
  value: number;
}

export const Thumbstick = (props: GamepadStateProps) => {
  const { gamepad, location } = props;
  // const isMobilePortrait = useMobilePortrait();

  // XInput thumbstick values range from -32768 to 32767
  const x = location === 'left' ? gamepad.sThumbLX : gamepad.sThumbRX;
  const y = location === 'left' ? gamepad.sThumbLY : gamepad.sThumbRY;

  const baseX = 1;
  const baseY = 1;

  const maxDelta = 20;

  const cx = baseX + (x / 32767) * maxDelta * 1;
  const cy = baseY + (y / 32767) * maxDelta * -1;

  const isThumbstickMoving = Math.abs(x) > 1000 || Math.abs(y) > 1000;
  const fillColor = isThumbstickMoving ? `rgba(250, 204, 21, 255)` : 'black';

  return (
    <svg
      id={(location as string).concat('-Stick')}
      width='127'
      height='127'
      viewBox='0 0 127 127'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={clsx(
        // isThumbstickMoving ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '',
        'pointer-events-auto touch-none overflow-visible',
      )}
      style={{ transform: `translate(${cx}px, ${cy}px)`, filter: isThumbstickMoving ? 'url(#shadow)' : 'none' }}
    >
      <g filter='url(#filter0_d_308_19960)'>
        <rect className='pointer-events-none' x='6' width='115' height='115' rx='57.5' fill={fillColor} fillOpacity='0.75' />
        <rect
          className='pointer-events-none'
          x='7.4375'
          y='1.4375'
          width='112.125'
          height='112.125'
          rx='56.0625'
          stroke='white'
          strokeOpacity='0.75'
          strokeWidth='2.875'
        />
        <circle className='pointer-events-none' cx='63.5' cy='23' r='5.75' fill='white' fillOpacity='0.75' />
        <circle className='pointer-events-none' cx='63.5' cy='92' r='5.75' fill='white' fillOpacity='0.75' />
        <circle className='pointer-events-none' cx='98' cy='57.5' r='5.75' transform='rotate(90 98 57.5)' fill='white' fillOpacity='0.75' />
        <circle className='pointer-events-none' cx='29' cy='57.5' r='5.75' transform='rotate(90 29 57.5)' fill='white' fillOpacity='0.75' />
      </g>
      <defs>
        <filter
          id='filter0_d_308_19960'
          x='0.25'
          y='0'
          width='126.5'
          height='126.5'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='5.75' />
          <feGaussianBlur stdDeviation='2.875' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_308_19960' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_308_19960' result='shape' />
        </filter>
        <filter id='shadow'>
          <feDropShadow dx='0' dy='0' stdDeviation='8' flood-color='rgba(250,204,21,0.75)' />
        </filter>
      </defs>
    </svg>
  );
};
